export default __webpack_public_path__ + "locales/it/Translations.json?hash=d957101a0156bb42a6f069a22c9369d7";